define('modules/resolution/main/resolution.controller',[
    "client"
], function(
    Prospector)
{
    Prospector.module("ResolutionAppRouter.Main", function(Main, Prospector, Backbone, Marionette, $, _){
        Main.Controller = {
            loadResolvePerson: function(options){
                require(["modules/resolution/main/views/resolve.person.view"],
                function(ResolvePersonView){
                    document.getElementsByTagName('title')[0].innerHTML = 'Resolve Person';
                    var view = new ResolvePersonView();
                    Prospector.mainRegion.show(view);
                });
            }
        }
    });
    return Prospector.ResolutionAppRouter.Main.Controller;
});
